import { render, staticRenderFns } from "./SalesTotal.vue?vue&type=template&id=08eac622&scoped=true&"
import script from "./SalesTotal.vue?vue&type=script&lang=js&"
export * from "./SalesTotal.vue?vue&type=script&lang=js&"
import style0 from "./SalesTotal.vue?vue&type=style&index=0&id=08eac622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eac622",
  null
  
)

export default component.exports